const productsJson = [
  {
    _id: "6717f81d04a57a4a4e2f94f1",
    title: "2024 Off Road Truck",
    prdCategory: "Buy",
    images: ["/prd1.jpeg", "/prd1-2.jpeg", "/prd1-3.jpeg", "/prd1-4.jpeg"],
    prdIndustry: "Construction",
    prdCondition: "Brand New",
    prdBrand: "Kato",
    prdType: "Off Road Trucks",
    ref_number: "AGA-101",
    opr_weight: "2000",
    manufacture: "Japan",
    workingHours: "0",
    cabType: "Cab Type",
    engineMake: "Komatsu",
    enginePower: "400",
    fuelCapacity: "2000",
    productColor: "Yellow",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:08:13.070+00:00",
  },
  {
    _id: "6717f87804a57a4a4e2f94f5",
    title: "2024 Truck Excavator",
    prdCategory: "Buy",
    images: ["/prd2.jpeg", "/prd2-2.jpeg", "/prd2-3.jpeg"],
    prdIndustry: "Quarry & Aggregate",
    prdCondition: "Brand New",
    prdBrand: "Tadano",
    prdType: "Excavators",
    ref_number: "AGA-102",
    opr_weight: "2000",
    manufacture: "China",
    workingHours: "0",
    cabType: "Cab Type",
    engineMake: "Komatsu",
    enginePower: "40",
    fuelCapacity: "1500",
    productColor: "Green",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:09:44.909+00:00",
  },
  {
    _id: "6717f8d404a57a4a4e2f94f9",
    title: "2023 Crawler Crane",
    prdCategory: "Buy",
    images: ["/prd3.jpeg", "/prd3-2.jpeg", "/prd3-3.jpeg", "/prd3-4.jpeg"],
    prdIndustry: "Mining",
    prdCondition: "Used",
    prdBrand: "Sany",
    prdType: "Crawler Cranes",
    ref_number: "AGA-103",
    opr_weight: "1500",
    manufacture: "Pakistan",
    workingHours: "Pakistan",
    cabType: "Cab Type",
    engineMake: "Komatsu",
    enginePower: "44",
    fuelCapacity: "850",
    productColor: "Gray",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:11:16.715+00:00",
  },
  {
    _id: "6717f93b04a57a4a4e2f94fd",
    title: "2022 Crawler Dozer",
    prdCategory: "Rent",
    images: ["/prd4.jpeg", "/prd4-2.jpeg", "/prd4-3.jpeg", "/prd4-4.jpeg"],
    prdIndustry: "Construction",
    prdCondition: "Used",
    prdBrand: "Sumitomo",
    prdType: "Crawler Dozers",
    ref_number: "AGA-104",
    opr_weight: "890",
    manufacture: "India",
    workingHours: "100",
    cabType: "Cab Type",
    engineMake: "Komatsu",
    enginePower: "44",
    fuelCapacity: "980",
    productColor: "Yellow",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:12:59.497+00:00",
  },
  {
    _id: "6717f98c04a57a4a4e2f9501",
    title: "2021 Wheel Loader",
    prdCategory: "Rent",
    images: ["/prd5.jpeg", "/prd5-2.jpeg", "/prd5-3.jpeg"],
    prdIndustry: "Oil & Gas",
    prdCondition: "Used",
    prdBrand: "Liebherr",
    prdType: "Wheel Loaders",
    ref_number: "AGA-105",
    opr_weight: "1500",
    manufacture: "Japan",
    workingHours: "140",
    cabType: "Cab Type",
    engineMake: "Japan",
    enginePower: "60",
    fuelCapacity: "960",
    productColor: "Gray and Yellow",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:14:20.760+00:00",
  },
  {
    _id: "6717f9f104a57a4a4e2f9505",
    title: "2024 Compactor",
    prdCategory: "Buy",
    images: ["/prd6.jpeg", "/prd6-2.jpeg", "/prd6-3.jpeg"],
    prdIndustry: "Quarry & Aggregate",
    prdCondition: "Brand New",
    prdBrand: "Zoomlion",
    prdType: "Compactors",
    ref_number: "AGA-106",
    opr_weight: "1500",
    manufacture: "Pakistan",
    workingHours: "0",
    cabType: "Cab Type",
    engineMake: "Pakistan",
    enginePower: "44",
    fuelCapacity: "1200",
    productColor: "Yellow",
    shortDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    longDescription:
      "Introducing the Kobelco SK850LC hydraulic crawler excavator line, a brand-new addition to the market featuring the revolutionary 3E technology. This 2024 excavator is designed to bring unparalleled power and efficiency to the worksite. Equipped with a standard bucket size of 4.3 – 5.1 m3, track guides (3 on each side, 6 in total), suspension seat, pre-air cleaner, travel alarm, remote monitoring system (KOMEXS), Automatic Engine Deceleration, and Auto Idle Stop (AIS), the SK850LC promises advanced features for enhanced excavation capabilities. Explore the future of excavation with the SK850LC",
    createdAt: "2024-10-22T19:16:01.386+00:00",
  },
];

export default productsJson;
